
import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { Breadcrumb, Button, Row, Col, Form, Input, Switch } from 'antd';
import PageTitle from '../components/PageTitle';
import FormLayout from '../components/FormLayout';
import PageLayout from '../components/PageLayout';
import InputPrefix from '../helper/InputPrefix';

export default function RoleUpdate() {
  const {state} = useLocation();
  const navigate = useNavigate();
  console.log(state)
  return (
    <PageLayout spinning={false}>
      <Col span={24}>
        <Breadcrumb separator=">">
          <Breadcrumb.Item href='/'>WiAdvance EIP</Breadcrumb.Item>
          <Breadcrumb.Item href='/'>角色管理</Breadcrumb.Item>
          <Breadcrumb.Item >編輯角色</Breadcrumb.Item>
        </Breadcrumb>
      </Col>
      <PageTitle>
        編輯角色
      </PageTitle>
      <Col span={24}>  
      <Form
        name="basic"
        // initialValues={{ remember: true }}
        onFinish={(value)=>{console.log(value)}}
        autoComplete="off"
      >
      <FormLayout>
        <Row align='top'>
          <InputPrefix label={'角色代碼'} require={true}/>
          <Col flex="auto">
            <Form.Item
              name="code"
              rules={[{ 
                  required: true,
                  message: '請輸入角色代碼' 
              }]}
            >
                <Input defaultValue={'roleCode'} placeholder="請輸入角色代碼" size={'large'} bordered={false} style={{borderBottom: '1px solid #ddd'}} disabled/>
            </Form.Item>
          </Col>
        </Row>
        <Row align='top'>
          <InputPrefix label={'角色名稱'} require={true}/>
          <Col flex="auto">
            <Form.Item
              name="name"
              rules={[{ 
                  required: true,
                  message: '請輸入角色名稱' 
              }]}
              >
                <Input defaultValue={state.role} placeholder="請輸入角色名稱" size={'large'} bordered={false} style={{borderBottom: '1px solid #ddd'}}/>
            </Form.Item>
          </Col>
        </Row>
        <Row align='top'>
          <InputPrefix label={'刪除狀態'} require={true}/>
          <Col flex="auto">
            <Form.Item
              name="status"
              >
                <Switch checkedChildren="啟用" unCheckedChildren="停用" checked={state.status}  />
            </Form.Item>
          </Col>
        </Row>
      </FormLayout>
      <Row align='bottom' style={{marginTop:'30px'}}>
          <Col>
            <Form.Item>
              <Button style={{width:'150px', marginRight:'10px'}} type="primary" htmlType="submit">更新</Button>
            </Form.Item>
          </Col>
          <Col>
            <Form.Item>
              <Button style={{width:'150px'}} onClick={()=>navigate('/role')}>取消</Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      </Col>
    </PageLayout>
  )
}
